import db, { storage } from './firebase';
import { v4 as uuidv4 } from 'uuid';

export const createPurchaseBillsDocument = async (details) => {
    // get the reference to the Firestore document
    const batch = db.batch();
    const uniqueId = uuidv4();
    const docRef = db.collection('PurchaseBills').doc();

    //create user object
    details.uniqueId = uniqueId;
    details.PurchaseBillsPostedDateTime = new Date();

    // write to Cloud Firestore
    const collectionRef = await db.collection('PurchaseBills').doc();
    batch.set(collectionRef, details);
    batch.commit().then(() => {
        return true;
    }).catch((error)=> {
        return false
    });
}

export const getPurchaseBillsDocumentWithUserId = async (userId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('PurchaseBills').where("userId","==", userId).get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const getPurchaseBillsDocumentWithUniqueId = async (uniqueId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('PurchaseBills').where("uniqueId", "==", uniqueId).get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const getPurchaseBillsDetails = async (uniqueId) => {
    // get the reference to the Firestore document
    let product = null;
    let retailer = null;
    const productSnapshot = await db.collection('PurchaseBills').where("uniqueId", "==", uniqueId).get()
    productSnapshot.docs.map(doc => {
        product = doc.data()
    });

    const employerSnapshot = await db.collection('Users').where("uid", "==", product.userId).get()
    employerSnapshot.docs.map(doc => {
        retailer = doc.data()
    });
    return {
        product: product,
        retailer: retailer
    }
}

export const getAllPurchaseBillsDocument = async () => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('PurchaseBills').get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const updatePurchaseBillsDocument = async (product) => {
    const docRef = db.doc(`/PurchaseBills/${product._id}`);
    return docRef.update(product);
}